module.exports = {"350503001":"东湖街道","350503002":"丰泽街道","350503003":"泉秀街道","350503004":"清源街道","350503005":"华大街道","350503006":"城东街道","350503007":"东海街道","350503008":"北峰街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350503.json
// module id = 1309
// module chunks = 0